var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLoadingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 400 400",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.27 87.561a5.83 5.83 0 1 1 8.244 8.245 5.83 5.83 0 0 1-8.244-8.245zM341.705 200c0-6.44 5.22-11.66 11.66-11.66s11.66 5.22 11.66 11.66-5.22 11.66-11.66 11.66-11.66-5.22-11.66-11.66zM296.132 296.1c6.83-6.83 17.904-6.83 24.734 0 6.831 6.831 6.831 17.905 0 24.735-6.83 6.83-17.904 6.83-24.734 0-6.831-6.83-6.831-17.904 0-24.735zM176.68 353.365c0-12.879 10.441-23.32 23.32-23.32s23.32 10.441 23.32 23.32-10.441 23.32-23.32 23.32-23.32-10.441-23.32-23.32zM71 287.859c11.381-11.382 29.835-11.382 41.217 0 11.381 11.382 11.381 29.835 0 41.217-11.382 11.382-29.836 11.382-41.218 0-11.381-11.382-11.381-29.835 0-41.217zM11.66 200c0-19.316 15.659-34.975 34.975-34.975 19.316 0 34.975 15.659 34.975 34.975 0 19.316-15.659 34.975-34.975 34.975-19.316 0-34.975-15.659-34.975-34.975zM62.755 62.723c15.935-15.935 41.771-15.935 57.707 0 15.935 15.936 15.935 41.772 0 57.707-15.936 15.936-41.772 15.936-57.708 0-15.935-15.935-15.935-41.772 0-57.707zM153.365 46.786C153.365 21.03 174.244.151 200 .151c25.756 0 46.635 20.88 46.635 46.635 0 25.756-20.879 46.635-46.635 46.635-25.756 0-46.635-20.879-46.635-46.635z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLoadingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "loading-icon.baa75ddbc6d3ccd947fb080428fcb94d.svg";